import { apiBusMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const busMapSettingsApiRoutes = {
    list: apiBusMapBaseURL + "settings/",
    listTransportAuthority: apiBusMapBaseURL + "settings/ta/",
    create: apiBusMapBaseURL + "settings/",
    createTransportAuthority: apiBusMapBaseURL + "settings/ta/",
    update: apiBusMapBaseURL + "settings/",
    updateTransportAuthority: apiBusMapBaseURL + "settings/ta/",
    delete: apiBusMapBaseURL + "settings/",
    fonts:  apiBusMapBaseURL + "settings/fonts/",
    fontsTransportAuthority:  apiBusMapBaseURL + "settings/fonts/ta/"
};

export class BusMapSettingsAPI {
    static create(busMapSettings) {
        return API.authenticatedRequest({
            url: busMapSettingsApiRoutes.create,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(busMapSettings)
        });
    }

    static createTransportAuthority(busMapSettings) {
        return API.authenticatedRequest({
            url: busMapSettingsApiRoutes.createTransportAuthority,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(busMapSettings)
        });
    }

    static update(busMapSettingsId, busMapSettings) {
        return API.authenticatedRequest({
            url: busMapSettingsApiRoutes.update + busMapSettingsId,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(busMapSettings)
        });
    }

    static updateTransportAuthority(busMapSettingsId, busMapSettings) {
        return API.authenticatedRequest({
            url: busMapSettingsApiRoutes.updateTransportAuthority + busMapSettingsId,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(busMapSettings)
        });
    }

    static delete(busMapSettingsId) {
        return API.authenticatedRequest({
            url: busMapSettingsApiRoutes.delete + busMapSettingsId,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static get(provider = '') {
        const url = busMapSettingsApiRoutes.list;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getTransportAuthority() {
        const url = busMapSettingsApiRoutes.listTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getFonts(provider = '') {
        const url = busMapSettingsApiRoutes.fonts;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getTransportAuthorityFonts() {
        const url = busMapSettingsApiRoutes.fontsTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}